export enum RumEventName {
    "Kale_Session_Start" = "Kale_Session_Start",
    "Kale_PDC_Filters_Loaded" = "Kale_PDC_Filters_Loaded",
    "Kale_PDC_Filter_Changed" = "Kale_PDC_Filter_Changed",
    "Kale_PDC_Warning_Modal_Shown" = "Kale_PDC_Warning_Modal_Shown",
    "Kale_PDC_Warning_Modal_Action" = "Kale_PDC_Warning_Modal_Action",
}
